import {ConfigText} from 'components/common/ConfigText'
import {useTrustBlockWidgets} from '../hooks/useTrustBlockWidgets'

type Props = {
  prefix: string
  defaultText: string
}

export const TrustBlockContent = ({prefix, defaultText}: Props) => {
  const widgetsData = useTrustBlockWidgets(prefix)

  if (widgetsData === null) {
    return null
  }

  if (widgetsData.length === 0) {
    return <>{defaultText}</>
  }

  return (
    <>
      {widgetsData.map(({code}) => {
        return <ConfigText key={code} configKey={code} defaultText={defaultText} />
      })}
    </>
  )
}
